import { AutocompleteValue } from '../components/AddressAutocomplete';
import { GeocodeResult } from 'use-places-autocomplete';
import { countries, CountryISO } from '@stax-core/lateralus-toolkit';

export const handleAddressAutocompleteSelect = (
  autocompleteValue: AutocompleteValue,
  fieldMapping: { [key: string]: string },
  mutator: (
    name: string,
    value: AutocompleteValue[keyof AutocompleteValue],
  ) => any,
) => {
  Object.keys(fieldMapping).forEach(item => {
    mutator(fieldMapping[item], autocompleteValue[item]);
  });
};

export const processAddressComponents = (
  addressComponents: GeocodeResult['address_components'],
): AutocompleteValue => {
  let streetAddress = '';
  let country: CountryISO | undefined;
  let state =
    addressComponents.find(c =>
      c.types.includes('administrative_area_level_1'),
    ) || null;
  const streetNumber = addressComponents.find(c =>
    c.types.includes('street_number'),
  );
  const route = addressComponents.find(c => c.types.includes('route'));
  const city = addressComponents.find(c => c.types.includes('locality'));
  const zip = addressComponents.find(c => c.types.includes('postal_code'));
  const countryA2 = addressComponents.find(c => c.types.includes('country'));

  if (countryA2) {
    // Google Places returns ISO3166-Alpha2 (US) and we need ISO3166-Alpha3 (USA)
    country = countries.find(country => country.isoA2 === countryA2.short_name);

    // If the country is not USA or CAN, we don't want to show a value for state.
    // We could provide this in the future since Google returns administrative_area_level_1 for all countries
    if (countryA2.short_name !== 'US' && countryA2.short_name !== 'CA') {
      state = null;
    }
  }

  if (streetNumber != null) {
    streetAddress += `${streetNumber.long_name} `;
  }
  if (route != null) {
    streetAddress += route.long_name;
  }

  return {
    streetAddress: streetAddress,
    city: city?.long_name || null,
    state: state?.short_name || null,
    zip: zip?.long_name || null,
    country: country?.iso || null,
  };
};
